import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './InputTextArea.scss';

export default class InputTextArea extends Component {
  render() {
    const {
      value,
      placeholder,
      onChange,
      template,
      id,
      rows,
    } = this.props;

    return (
      <div className={`InputTextArea${template ? ` template-${template}` : ''}`}>
        <div className={'group-input'}>
          <textarea
            id={id}
            placeholder={placeholder}
            rows={rows}
            value={value}
            onChange={event => onChange(event)}
          />    
        </div>
      </div>
    );
  }
}

InputTextArea.propTypes = {
  'id': PropTypes.string,
  'value': PropTypes.any,
  'placeholder': PropTypes.string,
  'onChange': PropTypes.func.isRequired,
  'template': PropTypes.string,
  'rows': PropTypes.any,
};
